/** A real published translation of the same source path, never a fallback. */
export function isGenuineLanguageQualifiedLanding(fullPath, page) {
  const match = String(fullPath).match(/^([a-z]{2})\/([a-z]{2})\/(.+)$/);
  return Boolean(match && page?.active === true && page.locale === match[1] &&
    page.language === match[2] &&
    String(page.full_path || "").replace(/^\/+|\/+$/g, "") === `${match[1]}/${match[3]}`);
}
